import React, { useState } from "react";
import { createPortal } from "react-dom";
import { MessageCircle, Phone, X, ArrowUpRight } from "lucide-react";

export const CONTACTO_PQR = { numero: "+57 312 364 9409", wa: "https://wa.me/573123649409", tel: "tel:+573123649409" };
export const CONTACTO_GENERAL = { numero: "+57 317 402 0014", wa: "https://wa.me/573174020014", tel: "tel:+573174020014" };

export const waConTexto = (c, texto) => `${c.wa}?text=${encodeURIComponent(texto)}`;

const OPCIONES = {
  cliente: [
    { id: "pqr", c: CONTACTO_PQR, titulo: "Solicitudes, quejas o reclamos (PQR)", area: "Dirección administrativa",
      detalle: "Para radicar una solicitud, queja o reclamo sobre el servicio de HUMAN." },
    { id: "general", c: CONTACTO_GENERAL, titulo: "Certificaciones, actualizaciones y novedades", area: "Atención a clientes y empleados",
      detalle: "Certificaciones, solicitudes de actualización de datos y novedades de tus empleados." },
  ],
  empleado: [
    { id: "general", c: CONTACTO_GENERAL, titulo: "Certificaciones, actualizaciones y novedades", area: "Atención a empleados",
      detalle: "Certificaciones laborales, actualización de tus datos, novedades y cualquier otra consulta." },
  ],
};

function Opcion({ o }) {
  return (
    <div className={`rounded-xl border p-4 ${o.id === "pqr" ? "border-vino-200 bg-vino-50/60" : "border-emerald-200 bg-emerald-50/60"}`} data-testid={`contacto-opcion-${o.id}`}>
      <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{o.area}</p>
      <p className="mt-0.5 font-semibold text-slate-900">{o.titulo}</p>
      <p className="mt-1 text-xs text-slate-600">{o.detalle}</p>
      <p className="mt-2 text-sm font-semibold text-slate-800" data-testid={`contacto-numero-${o.id}`}>{o.c.numero}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <a href={o.c.wa} target="_blank" rel="noopener noreferrer" data-testid={`contacto-wa-${o.id}`}
          className="flex items-center gap-1.5 rounded-lg bg-emerald-600 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-700">
          <MessageCircle className="h-4 w-4" /> Escribir por WhatsApp <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
        <a href={o.c.tel} data-testid={`contacto-tel-${o.id}`}
          className="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50">
          <Phone className="h-4 w-4" /> Llamar
        </a>
      </div>
    </div>
  );
}

// Botón «Contáctanos por WhatsApp»: cliente ve PQR (Dirección administrativa) y asuntos generales; empleado solo asuntos generales.
export function Contactanos({ tipo, variante = "sidebar" }) {
  const [abierto, setAbierto] = useState(false);
  const cls = variante === "sidebar"
    ? "flex w-full items-center gap-2.5 rounded-lg border border-emerald-500/40 bg-emerald-600/20 px-3 py-2.5 text-[13px] font-medium leading-tight text-emerald-50 transition-colors hover:bg-emerald-600/30"
    : "flex w-full items-center justify-center gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 px-3 py-3 text-sm font-semibold text-emerald-800";
  return (
    <>
      <button onClick={() => setAbierto(true)} className={cls} data-testid={`btn-contactanos-${variante}`}>
        <MessageCircle className="h-[18px] w-[18px] shrink-0" /> Contáctanos por WhatsApp
      </button>
      {abierto && createPortal(
        <div className="fixed inset-0 z-[70] flex items-end justify-center bg-black/50 sm:items-center sm:p-4" data-testid="modal-contactanos" onClick={() => setAbierto(false)}>
          <div className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-t-3xl bg-white p-6 shadow-2xl sm:rounded-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="mb-4 flex items-start justify-between gap-3">
              <div>
                <p className="font-display text-lg font-semibold text-slate-900">Contáctanos</p>
                <p className="mt-0.5 text-xs text-slate-500">{tipo === "cliente" ? "Elige el canal según el motivo de tu contacto." : "Te atendemos en este número."}</p>
              </div>
              <button onClick={() => setAbierto(false)} className="rounded-full p-1 text-slate-400 hover:bg-slate-100" data-testid="contactanos-cerrar" aria-label="Cerrar"><X className="h-5 w-5" /></button>
            </div>
            <div className="space-y-3">{OPCIONES[tipo].map((o) => <Opcion key={o.id} o={o} />)}</div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
